import { jsx as _jsx } from "react/jsx-runtime";
import { Check as CheckIcon } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { IconButton } from "@air/primitive-icon-button";
import { useBreakpointsContext } from "@air/provider-media-query";
import { resetSelectedItemsAction, selectAllSelectableItemsAction } from "@air/redux-selected-items";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ACTION_BAR_SELECT_ALL } from "~/constants/testIDs";
import { boardCollectionClipsSelector } from "~/store/boardCollection/selectors";
import { selectedClipsSelector } from "~/store/selectedItems/selectors";
export const BoardCollectionSelectAllButton = ()=>{
    const dispatch = useDispatch();
    const { isAboveMediumScreen } = useBreakpointsContext();
    const clips = useSelector(boardCollectionClipsSelector);
    const totalClips = Object.keys(clips).length;
    const selectedClips = useSelector(selectedClipsSelector);
    const allAreSelected = totalClips && totalClips === selectedClips.length;
    const onClick = useCallback(()=>{
        dispatch(allAreSelected ? resetSelectedItemsAction() : selectAllSelectableItemsAction());
    }, [
        allAreSelected,
        dispatch
    ]);
    if (isAboveMediumScreen) {
        return /*#__PURE__*/ _jsx(Button, {
            appearance: "ghost",
            color: "grey",
            size: "large",
            prefix: /*#__PURE__*/ _jsx(CheckIcon, {
                className: "size-4"
            }),
            onClick: onClick,
            disabled: !totalClips,
            "data-testid": ACTION_BAR_SELECT_ALL,
            children: allAreSelected ? "Deselect all" : "Select all"
        });
    }
    return /*#__PURE__*/ _jsx(IconButton, {
        appearance: "ghost",
        className: "mr-2",
        color: "grey",
        size: "large",
        icon: CheckIcon,
        label: allAreSelected ? "Deselect all" : "Select all",
        onClick: onClick,
        disabled: !totalClips,
        "data-testid": ACTION_BAR_SELECT_ALL
    });
};
